import type { EditorSDK } from '@wix/wix-data-client-common-standalone'

import { getCMSWebDuplicateCollectionPanelUrl } from './cms-web-panels'

async function openDuplicateCollectionPanel({
  editorSdkProxy,
  collectionId,
  hostname,
  origin,
}: {
  editorSdkProxy: EditorSDK
  collectionId: string
  hostname: string
  origin: string
}) {
  const [devMode, url] = await Promise.all([
    editorSdkProxy.editor.developerMode.isEnabled(),
    getCMSWebDuplicateCollectionPanelUrl({
      hostname,
      editorSdkProxy,
    }),
  ])

  await editorSdkProxy.editor.openModalPanel({
    url,
    initialData: {
      collectionId,
      origin,
    },
    shouldHideHeader: true,
    ...getPanelDimensions({ devMode }),
  })
}

function getPanelDimensions({ devMode }: { devMode: boolean }) {
  return devMode ? { width: 600, height: 408 } : { width: 600, height: 324 }
}

export default openDuplicateCollectionPanel
